var exports = {
  "uW": "TableGameRewardShowcase.module__section___TWZ0ZC",
  "DD": "TableGameRewardShowcase.module__title___TWZ0ZC",
  "Kk": "TableGameRewardShowcase.module__icon___TWZ0ZC",
  "L$": "TableGameRewardShowcase.module__toggle___TWZ0ZC",
  "B": "TableGameRewardShowcase.module__toggleTitle___TWZ0ZC",
  "RL": "TableGameRewardShowcase.module__toggleSummary___TWZ0ZC",
  "OW": "TableGameRewardShowcase.module__caret___TWZ0ZC",
  "cK": "TableGameRewardShowcase.module__tiers___TWZ0ZC",
  "Zm": "TableGameRewardShowcase.module__tier___TWZ0ZC",
  "Tm": "TableGameRewardShowcase.module__rank___TWZ0ZC",
  "FZ": "TableGameRewardShowcase.module__rewards___TWZ0ZC",
  "CZ": "TableGameRewardShowcase.module__reward___TWZ0ZC",
  "Sl": "TableGameRewardShowcase.module__image___TWZ0ZC",
  "ie": "TableGameRewardShowcase.module__crown___TWZ0ZC",
};

module.exports = exports;
